// removed by extract-text-webpack-plugin
module.exports = {"gap":"gap_D0epT","history_log":"history_log_1EKVo","log":"log_1aQTu","green":"green_1hLWg","red":"red_3IFkS","log_container":"log_container_3rCBW","header":"header_2dZLW","stretch_container":"stretch_container_1_Cwl","undo_redo":"undo_redo_3KMPn","last":"last_EfBRJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/history_panel/style.scss
// module id = 150
// module chunks = 0